var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "dashboard-component",
      attrs: {
        transition: "scale-transition",
        type: "table",
        "min-height": "600",
        "max-height": "700",
        loading: _vm.isLoading,
        elevation: _vm.elevation
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pull-up" },
        [
          _c(
            "v-card-title",
            { staticClass: "overline pb-0 d-flex justify-start" },
            [_c("h3", [_vm._v("Actividad Reciente")])]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pa-0 d-flex justify-center",
              attrs: { collapse: "", show: "" }
            },
            [
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("TicketDataTable", {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.tickets,
                              "show-details": "",
                              id: "dataTableTicket",
                              "hide-default-footer": ""
                            },
                            on: {
                              getFiltersTicketMenu: _vm.getFiltersTicketMenu,
                              getItemsPerPage: _vm.getItemsPerPage
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "grey lighten-4 ma-0 py-2",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("v-pagination", {
                            attrs: { length: _vm.pages, "total-visible": 7 },
                            on: {
                              input: function($event) {
                                return _vm.changePage()
                              }
                            },
                            model: {
                              value: _vm.page,
                              callback: function($$v) {
                                _vm.page = $$v
                              },
                              expression: "page"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }